import { useState, useEffect, useRef } from 'react'
export const useTop = (dis = 20) => {
  const [scrollNav, setScrollNav] = useState(false)
  const wrapRef = useRef<any>(null)
  useEffect(() => {
    const container = wrapRef.current
    const dHandleScroll = () => {
      const scrollTop = container?.scrollTop
      if (scrollTop > dis) {
        if (!scrollNav) setScrollNav(true)
      } else {
        if (scrollNav) setScrollNav(false)
      }
    }
    if (container) {
      container.addEventListener('scroll', dHandleScroll)
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', dHandleScroll)
      }
    }
  }, [wrapRef.current, scrollNav])
  return { wrapRef, scrollNav }
}
